import moment from "moment";
import { Row, Col } from "reactstrap";

export default function TrxHistory({ trx_history, onClick }) {
  return (
    <Row className="">
      {trx_history.map((hist: any, index: number) => {
        return (
          <Col md="3" onClick={() => onClick(hist)}>
            <div className="card process-card pointer ml-2 ">
              <div className="card-header">
                <h4 className="card-title">
                  <span className="card-number">{index + 1}</span>
                  <span className="mr-1"></span>{" "}
                  <i className="tim-icons icon-single-02 mr-1"></i>{" "}
                  {hist.updated_by_role}
                </h4>
              </div>
              <div className="card-body text-center">
                <p className="small mt-2">Status:</p>
                <h3 className="accepted text-primary"> {hist.action} </h3>
                {hist.updated_at !== "" ? (
                  <>
                    <p className="small mt-2">by</p>
                    <h4 className="comment text-primary">{hist.updated_by}</h4>
                    <p className="small mt-2">at</p>
                    <h4 className="comment text-primary">
                      {moment(hist.updated_at).format("DD-MMM-YYYY, h:mm a")}
                    </h4>
                  </>
                ) : (
                  ""
                )}
                {hist.note && hist.note !== "" ? (
                  <>
                    <p className="small mt-2">Comment</p>
                    <small className="comment dot-text" title={hist.note}>
                      {hist.note}
                    </small>
                  </>
                ) : (
                  ""
                )}
                {hist.created_by && hist.created_by !== "" ? (
                  <>
                    <p className="small mt-2">by</p>
                    <h4 className="text-primary">{hist.created_by}</h4>
                    <p className="small mt-2">at</p>
                    <h4 className="comment text-primary">
                      {" "}
                      {moment(hist.created_at).format("DD-MMM-YYYY, h:mm a")}
                    </h4>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          </Col>
        );
      })}
    </Row>
  );
}
